import { takeLatest, put, call, takeEvery, cancelled } from "redux-saga/effects";
import { toast } from "react-toastify";

//Redux Actions
import CONSTANTS from "../CONSTANTS";
import KitsService from "services/KitsService";
import { 
  actionSetEditKit, 
  actionSetKitsList, 
  actionSetKitTypes,
  actionSetKitsCount,
  actionSetPatientKits
} from "../actions/kitsActions";
import historyRouter from 'historyRouter';

function* sagaGetKit({ kitId }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.getKit, kitId, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Get kit failed');
    }
    yield put(actionSetEditKit(result.data));
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Get kit failed');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaGetKitsList({ page, limit, search }) {
  const cancelToken = KitsService.getSource();

  try {
    const result = yield call(KitsService.getKitsList, page, limit, search, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Get kits failed');
    }
    yield put(actionSetKitsList(result.data));
  } catch (error) {
    toast.error(error.message || 'Get kits failed');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaKitSubmitForm({ data }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.createKit, data, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Create kits failed');
    }
    toast.success('Kit created successfully');
    yield put(actionSetEditKit({}));
    historyRouter.goBack();
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Submit kit failed');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaKitSubmitEdition({ data }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.editKit, data, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Edit kits failed');
    }
    toast.success('Kit edited successfully');
    yield put(actionSetEditKit({}));
    historyRouter.goBack();
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Edit kit failed');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaKitDelete({ kitId }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.deleteKit, kitId, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Delete kits failed');
    }
    toast.success('Kit deleted successfully');
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Delete kit failed');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaGetKitTypes() {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.getTypes, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Error getting kit types');
    }
    yield put(actionSetKitTypes(result.data));
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Error getting kit types');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaGetKitCountByTypes() {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.getCountByTypes, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Error getting kits count');
    }
    yield put(actionSetKitsCount(result.data));
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Error getting kits count');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaGetPatientKits({ page, limit, search }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.getPatientKits, page, limit, search, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Error getting patient kits');
    }
    yield put(actionSetPatientKits(result.data));
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Error getting patient kits');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

function* sagaUpdatePatientKitStatus({ kitId, status }) {
  const cancelToken = KitsService.getSource();
  try {
    const result = yield call(KitsService.updatePatientKistStatus, kitId, status, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Error updating patient kit');
    }
    yield put(actionSetEditKit(result.data));
    toast.success("Kit state updated successfully");
  } catch (e) {
    console.log(e);
    toast.error(e.message || 'Error updating patient kit');
  } finally {
    if (yield cancelled()) {
      cancelToken.cancel();
    }
  }
}

export function* kitsSaga() {
  console.log("*Main Kits saga");
  yield takeLatest(CONSTANTS.KITS_GET, sagaGetKit);
  yield takeLatest(CONSTANTS.KITS_GET_LIST, sagaGetKitsList);
  yield takeLatest(CONSTANTS.KITS_SUBMIT_FORM, sagaKitSubmitForm);
  yield takeLatest(CONSTANTS.KITS_SUBMIT_EDIT, sagaKitSubmitEdition);
  yield takeLatest(CONSTANTS.KIT_DELETE, sagaKitDelete);
  yield takeLatest(CONSTANTS.KITS_GET_TYPES, sagaGetKitTypes);
  yield takeLatest(CONSTANTS.KITS_GET_COUNT_BY_TYPE, sagaGetKitCountByTypes);
  yield takeLatest(CONSTANTS.KITS_PATIENTS_GET, sagaGetPatientKits);
  yield takeLatest(CONSTANTS.KIT_PATIENTS_UPDATE_STATUS, sagaUpdatePatientKitStatus)
}
  